export const loginCommonConfig = {
  texts: {
    signInWithFacebook: 'Sign in with Facebook',
    signInWithGoogle: 'Sign in with Google',
    signInWithApple: 'Sign in with apple',
    continueWithEmail: 'Continue with Email',
    signInWithEmail: 'Sign in with Email',
    yourEmail: 'Your Email',
    verificationCode: 'Verification code',
    getVerificationCode: 'Get',
    signIn: 'sign in',
    userAgreement: 'if you continue,you agree to the',
    userAgreementLink: 'UserAgreement',
    and: 'and',
    privacyPolicyLink: 'Privacy Policy',
    logout: 'logout',
    loading: 'login...',
  },
}
